// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2979":"4f3db9d3289deb2c","5416":"294a497239f0438e","7957":"100375c5749f0556"}[chunkId] + ".css";
};